import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { login } from '../../services/auth';
import { useAuthStore } from '../../store/auth.store';

export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const nav = useNavigate();
  const isAuth = useAuthStore((s) => s.isAuthenticated());

  if (isAuth) {
    nav('/sessions');
    return null;
  }

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await login(email, password);
      nav('/sessions');
    } catch (err) {
      setError(
        (err as { response?: { data?: { error?: { message?: string } } } })
          ?.response?.data?.error?.message || 'Credenciais inválidas',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex h-screen items-center justify-center bg-[#0d0f12]">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-[#161a1f] border border-[#2a2f36] rounded-lg p-8 shadow-xl"
      >
        <h1 className="text-2xl font-bold text-red-500 mb-1">Oraculo</h1>
        <p className="text-sm text-gray-500 mb-6">AntiHack — admin login</p>

        <label className="block text-sm text-gray-400 mb-1">Email</label>
        <input
          type="email"
          required
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#0d0f12] border border-[#2a2f36] rounded px-3 py-2 mb-4 text-gray-200 focus:outline-none focus:border-red-500"
          placeholder="admin@oraculo.local"
        />

        <label className="block text-sm text-gray-400 mb-1">Senha</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-[#0d0f12] border border-[#2a2f36] rounded px-3 py-2 mb-6 text-gray-200 focus:outline-none focus:border-red-500"
        />

        {error && (
          <div className="bg-red-950 border border-red-800 text-red-300 text-sm rounded px-3 py-2 mb-4">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={submitting}
          className="w-full bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded px-4 py-2 transition"
        >
          {submitting ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
